module.exports = __webpack_public_path__ + "img/lbl02.f80a3ffb.png";